import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { CompanyService } from '../../../core/services/company/company.service';

@Component({
  selector: 'app-whatsapp-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './whatsapp-button.component.html',
  styleUrl: './whatsapp-button.component.scss',
})
export class WhatsappButtonComponent {
  private readonly companyService = inject(CompanyService);

  readonly whatsappUrl = computed(() => this.companyService.whatsappUrl());

  readonly isVisible = computed(() => !!this.whatsappUrl());
}
